/* eslint-disable @typescript-eslint/no-unused-vars */
import { Provider, SupabaseClient } from '@supabase/supabase-js';
import { useState } from 'react';
import { SocialLayout } from '@habity/types/auth';
import { Button, Divider, Text, HStack } from '@chakra-ui/react';
import * as SocialIcons from '../Icons';
import { useTranslations } from 'next-intl';
import { SITE_URL } from '~/constants/app';

interface SocialAuthProps {
  supabaseClient: SupabaseClient;
  socialLayout?: SocialLayout;
  providers?: Provider[];
  redirectTo?: RedirectTo;
  onlyThirdPartyProviders?: boolean;
  view?: 'sign_in' | 'sign_up' | 'magic_link';
}

type RedirectTo = undefined | string;

function SocialAuth({
  supabaseClient,
  providers = ['github', 'google', 'azure'],
  redirectTo,
  view = 'sign_in',
}: SocialAuthProps) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const t = useTranslations('Auth');

  const handleProviderSignIn = async (provider: Provider) => {
    setLoading(true);
    const redirectURL = `${SITE_URL}/auth/callback`;

    // SUPABASE: Direct auth call, can be made into server action
    const { error } = await supabaseClient.auth.signInWithOAuth({
      provider,
      options: {
        redirectTo: redirectURL,
      },
    });
    if (error) setError(error.message);
    setLoading(false);
  };

  function capitalize(word: string) {
    const lower = word.toLowerCase();
    return word.charAt(0).toUpperCase() + lower.slice(1);
  }

  return (
    <>
      {providers && providers.length > 0 && (
        <>
          {providers.map((provider: Provider) => {
            const icons = SocialIcons as TODO; // Fix types
            const AuthIcon = icons[provider];
            return (
              <Button
                key={provider}
                variant="secondary"
                iconSpacing="3"
                leftIcon={<AuthIcon />}
                onClick={() => handleProviderSignIn(provider)}
              >
                {t(`${view}.social_provider_text`, {
                  provider: capitalize(provider),
                })}
              </Button>
            );
          })}
          <HStack w="full" alignItems="center">
            <Divider />
            <Text fontSize="sm" color="gray.500" px={4}>
              ELLER
            </Text>
            <Divider />
          </HStack>
        </>
      )}
    </>
  );
}

export { SocialAuth };
